import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Paper, Typography, Button} from "@material-ui/core";
import {DeleteOutlineRounded} from "@material-ui/icons";
import {IConnections, IDataPartner, INotificacion} from "../../../types";
import {userService} from "../../../services/UserService";
import ConfirmacionGeneral from "../../../dialogs/ConfirmacionGeneral";
import axios from "axios";
import config from "../../../config.json";
import {partnerService} from "../../../services/PartnerService";

import DateUtils from "@date-io/moment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import moment from "moment/moment";


interface IProps {
    setUserSelectedIndex(index: number | null): void
    setCropsense(cropsense: boolean): void
    setDataPartner(data: IDataPartner): void
    setConnections(data: IConnections): void
    setLastConnections(data: Record<string, string>): void
    notify(notification: INotificacion): void
    partnerData: IDataPartner
    lastConnections: Record<string, string>
    userSelectedIndex: number | null
}

interface Istate {
    tipo: string
    superficie: number
    parcelas: number
    hover: string
    cultivos: string[]
    openConfirmacionEliminar: boolean
    messageConfirmacionEliminar: string
}


class ClientProps extends React.Component<IProps, Istate> {

    state:Istate = {
        tipo: "",
        superficie: 0,
        parcelas: 0,
        hover: "",
        cultivos: [] as string[],
        openConfirmacionEliminar: false,
        messageConfirmacionEliminar: ""
    }

    componentDidMount() {
        if (!this.props.partnerData.hasOwnProperty("users")) {
            setTimeout(() => this.componentDidMount(), 200)
            return
        }

        if (this.props.userSelectedIndex === null) return

        let tipo = "Otro"
        if (this.props.partnerData.users[this.props.userSelectedIndex]["level"] === 1) tipo = "Básico"
        if (this.props.partnerData.users[this.props.userSelectedIndex]["level"] === 2) tipo = "Avanzado"
        if (this.props.partnerData.users[this.props.userSelectedIndex]["level"] === 3) tipo = "Profesional"

        this.setState({tipo: tipo})

        let parcelas = this.props.partnerData.plots[this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]].length
        let superficie = 0

        let cultivos = [] as string[]

        for (let i = 0; i < parcelas; i++) {
            superficie += this.props.partnerData.plots[this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]][i]["superficie"] as number
            let cultivo = this.props.partnerData.plots[this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]][i]["cultivo"] as string
            if (!cultivos.includes(cultivo)) cultivos.push(cultivo)
        }

        this.setState({
            parcelas: parcelas,
            superficie: superficie,
            cultivos: cultivos
        })

        this.setState({
            messageConfirmacionEliminar: `¿Quieres eliminar al usuario ${this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]}?`
        })
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.userSelectedIndex !== nextProps.userSelectedIndex) this.componentDidMount()
        return true
    }

    cancelledDelete = () => {
        this.setState({openConfirmacionEliminar: false})
    }

    acceptedDelete = () => {
        this.setState({openConfirmacionEliminar: false})

        if (this.props.userSelectedIndex === null) return

        axios.get(
            config.url+`/delete/user?nombre=${this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]}`,
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .then((res) => {
                axios.get(
                    config.url+'/init/partner',
                    {auth: {
                            username: `${partnerService.getUser()}`,
                            password: `${partnerService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.setDataPartner(res.data)
                    })
                    .catch(() => {
                        this.props.notify({message: "Error solicitando datos", variant: 'error'})
                    })

                axios.get(
                    config.url+'/connections',
                    {auth: {
                            username: `${partnerService.getUser()}`,
                            password: `${partnerService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.setConnections(res.data)
                    })
                    .catch(() => {
                        this.props.notify({message: "Error solicitando datos", variant: 'error'})
                    })

                axios.get(
                    config.url+'/last/connections',
                    {auth: {
                            username: `${partnerService.getUser()}`,
                            password: `${partnerService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.setLastConnections(res.data)
                    })
                    .catch(() => {
                        this.props.notify({message: "Error solicitando datos", variant: 'error'})
                    })

                this.props.setUserSelectedIndex(null)

            })
            .catch(() => {
                this.props.notify({message: "Error eliminando usuario", variant: 'error'})
            })

    }

    handleChangeFin = (newDate: string) => {
        if (this.props.userSelectedIndex === null) return
        const user_name = this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]
        axios.post(
            config.url+'/edit/user',
            {
                nombre: user_name,
                fecha_caducidad: newDate
            },
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .then((res) => {
                axios.get(
                    config.url+'/init/partner',
                    {auth: {
                            username: `${partnerService.getUser()}`,
                            password: `${partnerService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.setDataPartner(res.data)
                        this.props.setUserSelectedIndex(this.props.userSelectedIndex)
                        this.props.notify({message: `Fecha de caducidad del usuario ${user_name} modificada correctamente`, variant: 'success'})
                    })
                    .catch(() => {
                        this.props.notify({message: "Error solicitando datos", variant: 'error'})
                    })

                axios.get(
                    config.url+'/connections',
                    {auth: {
                            username: `${partnerService.getUser()}`,
                            password: `${partnerService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.setConnections(res.data)
                    })
                    .catch(() => {
                        this.props.notify({message: "Error solicitando datos", variant: 'error'})
                    })

                axios.get(
                    config.url+'/last/connections',
                    {auth: {
                            username: `${partnerService.getUser()}`,
                            password: `${partnerService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.setLastConnections(res.data)
                    })
                    .catch(() => {
                        this.props.notify({message: "Error solicitando datos", variant: 'error'})
                    })

                this.props.setUserSelectedIndex(null)

            })
            .catch(() => {
                this.props.notify({message: "Error editando fecha de caducidad", variant: 'error'})
            })
    }

    render() {

        if (this.props.userSelectedIndex === null) {
            return <div/>
        }

        return (
            <Paper
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 20
                }}
            >
                <ConfirmacionGeneral
                    open={this.state.openConfirmacionEliminar}
                    message={this.state.messageConfirmacionEliminar}
                    cancelled={this.cancelledDelete}
                    accepted={this.acceptedDelete}
                />
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: 'calc(100% - 70px)'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            height: 140
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "60%",
                                height: "100%"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: 'calc(100% - 30px)'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 30,
                                        marginTop: 20,
                                        fontSize: 14
                                    }}
                                >
                                    {this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]}
                                </Typography>

                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        marginLeft: 30,
                                        marginTop: 5,
                                        fontSize: 14
                                    }}
                                >
                                    {this.props.partnerData.users[this.props.userSelectedIndex]["limite_ha"] === -1 ?
                                        "Ilim. Ha" + ", "
                                        :
                                        this.props.partnerData.users[this.props.userSelectedIndex]["limite_ha"] + " Ha" + ", "
                                    }
                                    {this.props.partnerData.users[this.props.userSelectedIndex]["limite_parcelas"] === -1 ?
                                        "Ilim. Parcelas"
                                        :
                                        this.props.partnerData.users[this.props.userSelectedIndex]["limite_parcelas"] + " parcelas"
                                    }
                                </Typography>

                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 30,
                                        marginTop: 5,
                                        fontSize: 14
                                    }}
                                >
                                    {Math.round(this.state.superficie/100)/100 + " Ha" + ", " + this.state.parcelas + " parcelas"}
                                </Typography>

                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: 30
                                }}
                            >
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 30,
                                        fontSize: 14
                                    }}
                                >
                                    {this.state.tipo}
                                </Typography>
                            </div>

                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                                height: "100%"
                            }}
                        >

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginTop: 20,
                                    fontSize: 14
                                }}
                            >
                                {"ini: " +
                                    (this.props.partnerData.users[this.props.userSelectedIndex]["fecha_creacion"] as string)
                                        .replace(/-/gi, '/')
                                }
                            </Typography>

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginTop: 5,
                                    fontSize: 14
                                }}
                            >
                                {"ult: " +
                                    this.props.lastConnections[this.props.partnerData.users[this.props.userSelectedIndex]["nombre"]]
                                }
                            </Typography>


                            <div
                                style={{
                                    marginRight: 20
                                }}
                            >
                                <MuiPickersUtilsProvider
                                    utils={DateUtils}
                                >
                                    <KeyboardDatePicker
                                        variant="inline"
                                        label="Fin:"
                                        value={(this.props.partnerData.users[this.props.userSelectedIndex]["fecha_caducidad"] as string).split("-").reverse().join("/")}
                                        onChange={(f) => {
                                            if (f !== null) {
                                                this.handleChangeFin(moment(f.toDate()).format('DD-MM-YYYY'))
                                            }
                                        }}
                                        format="DD/MM/YYYY"
                                    />
                                </MuiPickersUtilsProvider>
                            </div>

                        </div>

                    </div>

                    <div
                        style={{
                            width: '80%',
                            height: 0,
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderColor:'#4b484a',
                            alignSelf: "center",
                            marginTop: 50,
                            marginBottom:30
                        }}
                    />


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center"
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                width: 100,
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            Nombre:
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.userSelectedIndex]["nombre_usuario"] === null?
                                "-"
                                    :
                                (this.props.partnerData.users[this.props.userSelectedIndex]["nombre_usuario"] as string).length === 0?
                                    "-"
                                    :
                                this.props.partnerData.users[this.props.userSelectedIndex]["nombre_usuario"]
                            }
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                width: 100,
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            Apellidos:
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.userSelectedIndex]["apellidos"] === null?
                                "-"
                                :
                                (this.props.partnerData.users[this.props.userSelectedIndex]["apellidos"] as string).length === 0?
                                    "-"
                                    :
                                    this.props.partnerData.users[this.props.userSelectedIndex]["apellidos"]
                            }
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                width: 100,
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            e-mail:
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.userSelectedIndex]["email"] === null?
                                "-"
                                :
                                (this.props.partnerData.users[this.props.userSelectedIndex]["email"] as string).length === 0?
                                    "-"
                                    :
                                    this.props.partnerData.users[this.props.userSelectedIndex]["email"]
                            }
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                width: 100,
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            Teléfono:
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.userSelectedIndex]["telefono"] === null?
                                "-"
                                :
                                (this.props.partnerData.users[this.props.userSelectedIndex]["telefono"] as string).length === 0?
                                    "-"
                                    :
                                    this.props.partnerData.users[this.props.userSelectedIndex]["telefono"]
                            }
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                width: 100,
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            Confirmado:
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14
                            }}
                        >
                            {this.props.partnerData.users[this.props.userSelectedIndex]["confirmado"] === 1?
                                "Sí"
                                :
                                "No"
                            }
                        </Typography>
                    </div>

                    <div
                        style={{
                            width: '80%',
                            height: 0,
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderColor:'#4b484a',
                            alignSelf: "center",
                            marginTop: 50,
                            marginBottom:30
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                width: 100,
                                marginLeft: 30,
                                fontSize: 14
                            }}
                        >
                            Cultivos:
                        </Typography>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            {this.state.cultivos.map((cultivo) =>
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14
                                    }}
                                >
                                    {cultivo.replace(/_/gi, ' ')}
                                </Typography>
                            )}
                        </div>
                    </div>

                    <div
                        style={{
                            width: '80%',
                            height: 0,
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderColor:'#4b484a',
                            alignSelf: "center",
                            marginTop: 50,
                            marginBottom:30
                        }}
                    />

                    <Button
                        style={{
                            textTransform: "none"
                        }}
                        onClick={() => {
                            if (this.props.userSelectedIndex !== null) {
                                let user = this.props.partnerData.users[this.props.userSelectedIndex]["nombre"] as string
                                let pass = this.props.partnerData.users[this.props.userSelectedIndex]["pass"] as string
                                userService.login(user, pass)
                                setTimeout(() => this.props.setCropsense(true), 500)

                            }
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                margin: 20,
                                fontSize: 14
                            }}
                        >
                            Ver en CropSense
                        </Typography>
                    </Button>


                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-around",
                        width: "100%",
                        height: 70
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 100,
                            height: 40,
                            borderRadius: 10,
                            borderStyle: "solid",
                            borderBlockColor: "black",
                            borderWidth: this.state.hover === "cerrar"? 2 : 1,
                            cursor: "pointer"
                        }}
                        onMouseEnter={() => this.setState({hover: 'cerrar'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => this.props.setUserSelectedIndex(null)}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                textAlign: "center",
                                fontSize: 16,
                                fontWeight: this.state.hover === "cerrar"? "bold" : "normal"
                            }}
                        >
                            Cerrar
                        </Typography>
                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 120,
                            height: 40,
                            borderRadius: 10,
                            borderStyle: "solid",
                            borderWidth: this.state.hover === "eliminar"? 2 : 1,
                            cursor: "pointer",
                            borderColor: "#ff0000",
                        }}
                        onMouseEnter={() => this.setState({hover: 'eliminar'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => {this.setState({openConfirmacionEliminar: true})}}
                    >
                        <DeleteOutlineRounded
                            style={{
                                width: 22,
                                height: 22,
                                marginTop: -4,
                                color: "#ff0000"
                            }}
                        />
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                textAlign: "center",
                                color: "#ff0000",
                                fontSize: 16,
                                marginLeft: 5,
                                fontWeight: this.state.hover === "eliminar"? "bold" : "normal"
                            }}
                        >
                            Eliminar
                        </Typography>
                    </div>

                </div>

            </Paper>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner,
    lastConnections: state.partner.lastConnections,
    userSelectedIndex: state.partner.userSelectedIndex
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setUserSelectedIndex: (index: number | null) => dispatch({type: "set-user-selected-index", index}),
    setCropsense: (cropsense: boolean) => dispatch({type: "set-cropsense", cropsense}),
    setDataPartner: (data: IDataPartner) => dispatch({type: "set-data-partner", data}),
    setConnections: (data: IConnections) => dispatch({type: "set-connections", data}),
    setLastConnections: (data: Record<string, string>) => dispatch({type: "set-last-connections", data}),
    notify: (notification: INotificacion) => dispatch({type: 'notify-partners', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientProps);
